export default [
  {
    answer:
      "You’ll pay your retailer directly when you pick your order up, or when it’s delivered.",
    question: "How, when, who do I pay?",
  },
  {
    answer:
      'You can pre-order for tomorrow after a retailer has closed for the day. You cannot currently order further out than next day’s business. <span class="font-bold">Please note</span>: It’s up to each retailer to enable this pre-order feature. If they haven’t yet turned it on, let them know their customers want it!',
    question: "Can I place an order for tomorrow or later?",
  },
  {
    answer:
      "You’ll get a text from the retailer letting you know it’s time to come in. (If you don't receive a text, check your Leafly profile to verify you've opted into notifications.)",
    question: "How will I know when my order is ready for pickup?",
  },
  {
    answer: "There is no fee for ordering. You only pay for what you ordered.",
    question: "How much does it cost to place an order?",
  },
  {
    answer:
      "Android: Yes.\n iOS: It's not possible to order through the iOS app. You'll need to place your order directly through Leafly.com.",
    question: "Can I order through the Leafly app?",
  },
  {
    answer:
      "Yes. Any deal listed on a retailer’s Leafly menu will show up at the discounted price in your Leafly cart.",
    question: "Will deals on Leafly apply to my order automatically?",
  },
  {
    answer:
      "No, but you can (and should!) ask for it at the store at time of purchase. Store promotions can only be applied by the retailer.",
    question: "Can I apply store promotions to my order?",
  },
];
